document.addEventListener('rebuy.ready', (e) => {
  const swiperEls = document.querySelectorAll('.js-rebuy-widget-carousel');

  if (swiperEls || swiperEls.length) {
    swiperEls.forEach(swiperEl => {
      const paginationEl = swiperEl.querySelector('.js-swiper-pagination');
      const swiper = new Swiper(swiperEl, {
        slidesPerView: 2,
        spaceBetween: 16,
        pagination: {
          el: paginationEl,
          type: "progressbar"
        },
        breakpoints: {
          700: {
            slidesPerView: 2
          },
          1024: {
            slidesPerView: 3
          },
          1200: {
            slidesPerView: 4
          }
        }
      })
    })
  }

  window.selectVariantByCustom = function (variant, product) {
    if (variant) {
      product.selected_variant = variant
    }
  }
})